import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'iva'
})
export class IvaPipe implements PipeTransform {



  transform(value: number|null, ...args: unknown[]): string {
    
    if(value==null){
      return "-----"
    }
    if(value == 1){
      return "Responsable Inscripto";
    } 
  }

}
